import { Component, OnInit } from '@angular/core';
// import { FormGroup } from '@angular/forms';
// import { Router, ActivatedRoute } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { NewTeamService } from '../new-team/new-team.service';
import { RedirectService } from '../redirect/redirect.service';
import { TeamDetailsService } from './team-details.service';
declare var $: any;
@Component({
    selector: 'app-team-details',
    templateUrl: './team-details.component.html',
    styleUrls: ['./team-details.component.scss']
})

export class TeamDetailsComponent implements OnInit {
    teamObj: any = {};
    notificationEmails: any;
    notificationEmailsError: boolean = false;
    // teamForm: FormGroup;
    errMessage: string = '';
    userRoles = [
        {
            name: 'WebAdmin',
            id: 'webAdmin'
        },
        {
            name: 'Supervisor',
            id: 'supervisor'
        },
        {
            name: 'Operator',
            id: 'operator'
        }
    ]

    constructor(
        private _teamDetailsService: TeamDetailsService,
        private _activatedRoute: ActivatedRoute,
        // private _router: Router,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _newTeamService: NewTeamService,

    ) { }

    ngOnInit() {

        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.teamObj.admins = [];
            this._teamDetailsService.getTeamDetails(this._activatedRoute.snapshot.params.id)
                .subscribe(
                    (result: any) => {
                        let notificationEmails = [];
                        this.teamObj = result.data;
                        this.teamObj.validUpto = moment(this.teamObj.validUpto).format('MM-DD-YYYY');
                        this.teamObj.admins = _.orderBy(this.teamObj.admins, [user => user.name.toLowerCase()], ['asc']) 
                        _.forEach(this.teamObj.notificationEmails, function (value) {
                            notificationEmails.push({ 'displayValue': value });
                            });
                            console.log('notif', this.notificationEmails);
                            this.notificationEmails = notificationEmails;
                    },
                    (err: any) => {
                        console.log('err ', err);
                    });
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    deactivateTeam(id) {
        console.log('deactivate', id);
        this._teamDetailsService.deactivateTeam(id)
            .subscribe(
                (result: any) => {
                    console.log('Team Deactivated Successfully');
                },
                (err: any) => {
                    console.log('err ', err);
                });
    }

     updateTeam() {
        let updatedNotificationEmails = _.map(this.notificationEmails, "displayValue");
        let updateObj = {
            _id: this.teamObj._id,
            notificationEmails: updatedNotificationEmails
        };
        this._newTeamService.updateTeam(updateObj)
            .subscribe(
                (result) => {
                    console.log('result ', result);
                    // this._router.navigateByUrl('/teamsList');
                },
                (err) => {
                    this.errMessage = err.error.message;
                }
            );
    }


    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    onTagsChanged(event) {
        // console.log('hello world');
        this.notificationEmailsError = false;
        if (event.tag.displayValue && !this.validateEmail(event.tag.displayValue)) {
            let curEmail = this.notificationEmails[this.notificationEmails.length -1].displayValue;
            setTimeout(function(){
                $("#notificationEmails .tags-input__input-field")[0].value = curEmail;
            },10);
            this.notificationEmails.pop();
            this.notificationEmailsError = true;
        }
        else {
            this.updateTeam();
        }
    }

    onStatusChange(userId, status) {
        const teamId = this._activatedRoute.snapshot.params.id;
        this._teamDetailsService.updateUserStatus(teamId, userId, {status: status}).subscribe((response: any) => {
            if(response['success']) {
                this.ngOnInit();
            }
        })
    }

    onRoleChange(userId, role) {
        const teamId = this._activatedRoute.snapshot.params.id;
        this._teamDetailsService.updateUserRole(teamId, userId, {role: role}).subscribe((response: any) => {
            if(response['success']) {
                this.ngOnInit();
            }
        })
    }
}





// WEBPACK FOOTER //
// ./src/app/team-details/team-details.component.ts